import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import queryString from "query-string";
import { castArray, includes, map, range } from "lodash";
import { urlFiltersParser, updateUrlFilter } from 'utils';
import _ from "i18n";
import { setStatisticsApplicationFilter, setStatisticsEventsFilter } from "../../../actions/actions"
import __ from "lodash";
//import StatisticAppTypeFilter from "./StatisticAppTypeFilter";

const DocumentApplicationFilters = ({ statisticsFilter, setStatisticsApplicationFilter, setStatisticsEventsFilter }) => {
  const defaultCheckedList = ['EVENT'];
  const plainOptions = [
    'EVENT',
    'UA',
    'PAPER',
  ];
  const initFromFilter = () => {
    const urlParams = queryString.parse(location.search);

    if (!urlParams.filters) {
      return defaultCheckedList;
    }

    let filter = urlFiltersParser(urlParams.filters);

    if (!filter || filter.length <= 0) {
      return defaultCheckedList;
    }

    let periodFilter = filter.filter(item => 'app' === item.property);
    if (!periodFilter || periodFilter.length <= 0 || !periodFilter[0].value) {
      return defaultCheckedList;
    }

    return castArray(periodFilter[0].value);
  };
  const [checkedList, setCheckedList] = useState(initFromFilter());



  useEffect(() => {

    const filter = initFromFilter();
    const checkedList = __.uniq([...statisticsFilter.apps, ...filter]);

    setCheckedList(checkedList);

    updateUrlFilter('app', 'in', checkedList);


    setStatisticsApplicationFilter(checkedList);
  }, []);


  useEffect(() => {
      setCheckedList(statisticsFilter.apps);
  }, [statisticsFilter.apps]);



  const onChange = (checkedList) => {
    setCheckedList(checkedList);
    setStatisticsApplicationFilter(checkedList);
  };

  const toggleDescriminantChecked = (event) => {
    const operation = event.target.dataset.operation;
    //let { checkedList } = this.state;
    setCheckedList(prev => prev.includes(operation) ? prev.filter(item => item !== operation) : [...prev, operation])
    const checkedList = checkedList.includes(operation) ?
      checkedList.filter(item => item !== operation) :
      [...checkedList, operation];

    setCheckedList(checkedList);
    setStatisticsApplicationFilter(checkedList);

    updateUrlFilter('app', 'in', checkedList);

  };

    return (<div>

      {/* <div className="hidden">
        <Checkbox.Group options={this.plainOptions} value={this.state.checkedList} onChange={this.onChange}/>
      </div>
        <nav>
        <Button  type={this.state.checkedList.includes('EVENT') ? 'primary' : 'default'} data-operation="EVENT" onClick={this.toggleDescriminantChecked}>{_('EVENT')}
          {this.state.checkedList.includes('EVENT') ?
            <Icon type="close"/> : null}
        </Button>
        <Button  type={this.state.checkedList.includes('UA') ? 'primary' : 'default'} data-operation="UA" onClick={this.toggleDescriminantChecked}>{_('UA')}

          {this.state.checkedList.includes('UA') ?
            <Icon type="close"/> : null}

        </Button>
        <Button  type={this.state.checkedList.includes('PAPER') ? 'primary' : 'default'} data-operation="PAPER" onClick={this.toggleDescriminantChecked}>{_('PAPER')}
          {this.state.checkedList.includes('PAPER') ?
            <Icon type="close"/> : null}
        </Button>
        </nav> */}


    </div>);
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter
});

const mapDispatchToProps = {
  setStatisticsApplicationFilter,
  setStatisticsEventsFilter
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentApplicationFilters);



// WEBPACK FOOTER //
// ./app/components/Filters/Statistics/DocumentApplicationFilters.js